import get from 'lodash.get';

const getSiteProgressChecklist = (rootState) =>
  get(rootState, 'ws.site.properties.siteProgressChecklist', {});

export default getSiteProgressChecklist;
